function Health() {
    const version = process.env.REACT_APP_VERSION;

    console.log(`Application version: ${version}`);

    return (
        <div>
            <pre>
                {JSON.stringify({
                    name: "accountservice-frontend",
                    status: "healthy",
                    applicationVersion: version
                }, null, 2)}
            </pre>
        </div>
    );
}

export default Health;